import { AdCard, CreateNewAd } from '@/features/ad';
import { useGetUserAdsQuery } from '@/models/ad';
import { LoadingAds } from '@/pages/partner-home/running-ads/components';

export const InReview = () => {
  const { data, isLoading } = useGetUserAdsQuery({ reviewStatus: 'PENDING' });

  return (
    <div className="flex flex-col w-full">
      {data && data.length > 0 && (
        <div className="grid w-full grid-cols-1 gap-4 mt-2 md:grid-cols-2 lg:grid-cols-4">
          {data.map((it) => (
            <div key={it.id}>
              <AdCard
                id={it.id}
                url={it.url}
                title={it.title}
                date={it.createdAt}
                stats={it.stats}
              />
            </div>
          ))}
          <CreateNewAd />
        </div>
      )}

      {isLoading && !data && <LoadingAds size={4} />}

      {!isLoading && data && data.length === 0 && (
        <div className="grid w-full grid-cols-1 gap-4 mt-2 md:grid-cols-2 lg:grid-cols-4">
          <CreateNewAd />
        </div>
      )}
    </div>
  );
};
